import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { routes } from '../config/routes';

export const useNavigation = () => {
    const navigate = useNavigate();

    const navigateTo = useCallback((routeName, params = {}) => {
        if (!routes[routeName]) {
            console.error(`Rota "${routeName}" não encontrada`);
            return;
        }

        // Handle route with params
        let path = routes[routeName].path;
        const queryParams = [];

        // Replace route params
        if (params) {
            // Handle path params (e.g., /resource/:id)
            Object.keys(params).forEach(key => {
                const pathParamPattern = new RegExp(`:${key}\\b`);
                if (pathParamPattern.test(path)) {
                    path = path.replace(pathParamPattern, params[key]);
                    delete params[key];
                }
            });

            // Add remaining params as query params
            Object.keys(params).forEach(key => {
                queryParams.push(`${key}=${encodeURIComponent(params[key])}`);
            });
        }

        // Append query params if any
        if (queryParams.length > 0) {
            path = `${path}?${queryParams.join('&')}`;
        }

        navigate(path);
    }, [navigate]);

    return { navigateTo };
};

export default useNavigation;